import React from "react";
import { Tooltip, Typography } from "antd";
import { WarningOutlined } from "@ant-design/icons";
import ItemizedJobCard from "components/jobs/ItemizedJobCard";
import DateRangeStart from "components/jobs/DateRangeStart";
import { BatchJobItem } from "reducers/types";
import { rangeLabel } from "pages/jobs/rangeLabel";


const tefasDetails = (item: BatchJobItem) => {
  if (item.status === "NO_DATA") {
    return <Typography.Text type="secondary">no data (weekend/holiday)</Typography.Text>;
  }
  const d = item.details;
  if (!d) {
    return null;
  }
  return (
    <Typography.Text type="secondary">
      written {d.written} / fetched {d.fetched}
      {d.carried > 0 ? ` · ${d.carried} carried` : ""}
      {d.documentCreated > 0 ? ` · ${d.documentCreated} created` : ""}
      {d.kept > 0 ? ` · ${d.kept} kept` : ""}{" "}
      {d.fetched > 0 && d.written === 0 ? (
        <Tooltip title="TEFAS returned prices, but no active catalogue fund matched">
          <WarningOutlined style={{ color: "#faad14" }} />
        </Tooltip>
      ) : null}
    </Typography.Text>
  );
};

// TEFAS history for a date range, processed date by date on the server (job type tefas-history).
const TefasHistoryCard: React.FC = () => (
  <ItemizedJobCard
    title="TEFAS Parity History"
    basePath="/admin/resources/update/tefas/history"
    providerName="TEFAS"
    start={({ start }) => <DateRangeStart onStart={start} onlyPast withOverride />}
    renderLabel={rangeLabel}
    renderDetails={tefasDetails}
  />
);

export default TefasHistoryCard;
